import React from 'react';
import HelpArticle from '../../components/help/HelpArticle';

const FindTool: React.FC = () => {
  const content = (
    <>
      <h2>Find det rigtige værktøj til dit projekt</h2>
      <p>
        DoMore gør det nemt at finde præcis det værktøj, du har brug for. Her er nogle tips til at optimere din søgning.
      </p>

      <h3>Brug søgefunktionen</h3>
      <p>
        På forsiden finder du en søgebar, hvor du kan indtaste navnet på det værktøj, du leder efter. For eksempel "boremaskine", "stige" eller "plæneklipper".
      </p>

      <h3>Gennemse kategorier</h3>
      <p>
        Klik på "Find værktøj" i menuen for at se alle tilgængelige kategorier:
      </p>
      <ul>
        <li><strong>Elværktøj:</strong> Boremaskiner, save, slibemaskiner</li>
        <li><strong>Håndværktøj:</strong> Hammere, skruenøgler, tang</li>
        <li><strong>Have & udendørs:</strong> Plæneklippere, hækkeklippere, haveværktøj</li>
        <li><strong>Og mange flere kategorier...</strong></li>
      </ul>

      <h3>Brug filtrene</h3>
      <p>
        På søgesiden kan du filtrere resultaterne efter:
      </p>
      <ul>
        <li><strong>Pris:</strong> Sæt din prisgrænse per dag</li>
        <li><strong>Afstand:</strong> Find værktøj tæt på dig</li>
        <li><strong>Tilgængelighed:</strong> Se kun værktøj tilgængeligt på bestemte datoer</li>
        <li><strong>Bedømmelse:</strong> Vælg værktøj med høje ratings</li>
      </ul>

      <h3>Se værktøjsdetaljer</h3>
      <p>
        Klik på et værktøj for at se:
      </p>
      <ul>
        <li>Detaljeret beskrivelse</li>
        <li>Billeder fra forskellige vinkler</li>
        <li>Pris per dag</li>
        <li>Placering og afstand fra dig</li>
        <li>Tilgængelighedskalender</li>
        <li>Ejerens profil og anmeldelser</li>
      </ul>

      <h3>Kontakt ejeren</h3>
      <p>
        Har du spørgsmål til værktøjet? Brug chatfunktionen til at kontakte ejeren direkt. De kan svare på spørgsmål om:
      </p>
      <ul>
        <li>Værktøjets tilstand og alder</li>
        <li>Hvordan det bruges</li>
        <li>Hvad der følger med (tilbehør, manualer)</li>
        <li>Afhentnings- og returneringsmuligheder</li>
      </ul>

      <h3>Gem favoritter</h3>
      <p>
        Klik på hjertet på værktøj, du er interesseret i, for at gemme det til senere. Find dit gemte værktøj under "Favoritter" i din profil.
      </p>
    </>
  );

  return (
    <HelpArticle
      title="Find det rigtige værktøj"
      category="Kom i gang"
      content={content}
      relatedArticles={[
        { title: 'Foretag din første booking', link: '/help/first-booking' },
        { title: 'Bookingprocessen forklaret', link: '/help/booking-process' },
      ]}
    />
 );
};

export default FindTool;
